export default __webpack_public_path__ + "static/media/36.530aade8.jpeg";